import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  EventEmitter,
  inject,
  Input,
  Output
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-search-input',
  standalone: true,
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchInputComponent implements AfterViewInit {
  @Input() clearSearchTrigger = new EventEmitter<void>();
  @Input() placeholder = $localize`Search`;
  @Output() valueChange = new EventEmitter<string>();

  private destroyRef = inject(DestroyRef);

  public value = '';

  public handleSearchChanged(event: Event) {
    const target = event.target as HTMLInputElement;
    this.value = target.value;
    this.valueChange.emit(target.value);
  }

  public ngAfterViewInit(): void {
    this.clearSearchTrigger.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.value = '';
      this.valueChange.emit('');
    });
  }
}
